<div class="ipm-pro-kits-page-container">
  <div class="ipm-container">
    <div class="ipm-pro-kits-header">
      <!-- Back Button -->
      <div class="ipm-back-button" (click)="goBack()">
        <i class="pi pi-arrow-left"></i>
        <span>Back</span>
      </div>

      <!-- Title Section with Search -->
      <div class="ipm-title-section">
        <div class="ipm-title-wrapper">
          <div class="golden-icon-wrapper" style="--credit-icon-mask: url('./assets/imgs/subs-pro-icons/credit-pro.png')">
            <img priority src="./assets/imgs/subs-pro-icons/credit-pro.png" alt="beat-placement">
          </div>
          <h1>KITS22</h1>
        </div>
        <ipm-filter-section 
          class="ipm-search-filter"
          [isShowFilterOptions]="false" 
          [isShowSearch]="true"
          [isShowSort]="false"
          [isComponentType]="'pro-kits'"
          [isShowLayoutChange]="false"
          [searchPlaceholder]="'Search top sound kits'">
        </ipm-filter-section>
        <ipm-filter-section 
          class="ipm-mobile-filter"
          [isShowFilterOptions]="isShowFilter" 
          [isShowSearch]="false"
          [isShowSort]="true"
          [isComponentType]="'pro-kits'"
          [isShowLayoutChange]="false">
        </ipm-filter-section>
      </div>
    </div>

    <!-- Use existing filter section component for desktop -->
    <!-- <ipm-filter-section 
      class="ipm-desktop-filter"
      [isShowFilterOptions]="isShowFilter" 
      [isShowSearch]="false"
      [isShowSort]="true"
      [isComponentType]="'pro-kits'"
      [isShowLayoutChange]="false">
    </ipm-filter-section> -->
    <div class="separator"></div>
    <!-- Pro Kits Grid -->
    <div *ngIf="isDataLoaded" class="ipm-pro-kits-grid">
      <ipm-beats [soundKitsList]="proKitsList" [renderType]="'soundKit'" [isProKit]="true"></ipm-beats>
      <ipm-loading-spinner *ngIf="isShowLoaderPagination"></ipm-loading-spinner>
    </div>
  </div>
</div>
